import { BrickContext, ActionBrick, registerBrick, File, ErrorFlow } from 'olympe';
import {getAsArray} from "./helpers";
import {getLogger} from "@olympeio/core";

export default class SerializeFile extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {function()} forwardEvent
     * @param {function(*)} setJsonObject
     * @param {function(*)} setErrorFlow
     */
    update($, [file], [forwardEvent, setJsonObject, setErrorFlow]) {
        let files = [];
        if (file instanceof File) {
            files.push(file);
        } else {
            const { array, error } = getAsArray(file);
            if (error) {
                getLogger('Serialize File').error(error.message);
                return;
            } else {
                files = array;
            }
        }

        const filesContent = [];
        files.forEach(file => {
            file.getContentUrl((content) => {
                filesContent.push({error: false, tag: file.getTag(), name: file.get(File.fileNameProp), mimetype: file.get(File.mimeTypeProp), content: content});
            }, (error) => {
                filesContent.push({error: error});
            });
        });

        this.waitAndSendJSON(files, filesContent, file instanceof File, forwardEvent, setJsonObject, setErrorFlow)
    }

    waitAndSendJSON(files, filesContent, returnSingleObject, forwardEvent, setJsonObject, setErrorFlow) {
        setTimeout(() => {
            if(filesContent.length === files.length) {
                const errors = filesContent.filter(c => c.error !== false);
                if (errors.length > 0) {
                    setErrorFlow(ErrorFlow.create('Cannot get file content: ' + errors.reduce((a,c) => c + a.error + ';', ''), 1));
                } else {
                    setJsonObject(returnSingleObject ? filesContent[0] : filesContent);
                    forwardEvent();
                }
            } else {
                this.waitAndSendJSON(files, filesContent, returnSingleObject, forwardEvent, setJsonObject, setErrorFlow);
            }
        }, 500);
    }
}

registerBrick('018e97c7820c82f7aaee', SerializeFile);
